export default "__VITE_ASSET__hOzVVeJ0__"